<template>
  <button class="no-member__close" @click="closeStateDialog">
    <IconClose aria-label="Dialog schließen" />
  </button>
  <h2 class="no-member__title h5">Sie sind noch kein ÖAMTC Mitglied</h2>
  <p class="no-member__subtitle">
    Sie können dennoch gerne einen Termin vereinbaren. Bitte beachten Sie, dass am Stützpunkt eine
    kostenpflichtige Mitgliedschaft abgeschlossen werden muss.
  </p>
  <p class="no-member__subtitle">
    Alternativ können Sie auch gleich online Mitglied werden und anschließend einen Termin
    vereinbaren.
  </p>
  <a class="link" target="_blank" href="https://www.oeamtc.at/mitgliedschaft/"
    >Online Mitglied werden</a
  >
  <div class="no-member__button">
    <Button @click="confirm">Einverstanden</Button>
  </div>
</template>

<script>
import IconClose from '@/components/icons/IconClose.vue'
import { mapGetters } from 'vuex'
import Button from '../Button.vue'

export default {
  components: { IconClose, Button },
  emits: ['closeNoMemberDialog', 'confirm'],
  computed: {
    ...mapGetters(['federalStates']),
  },
  methods: {
    closeStateDialog() {
      this.$emit('closeNoMemberDialog')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss">
.no-member {
  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }

  #content &__title,
  &__title {
    font-weight: $font-weight-medium;
    margin-bottom: 8px;
    font-size: 16px;
    line-height: $line-height;
  }

  &__subtitle {
    color: $color-text-secondary;
    margin-bottom: 24px;
  }

  &__button {
    margin-top: 24px;
    display: flex;
    justify-content: stretch;

    .button {
      width: 100%;
    }

    @media (min-width: $breakpoint-mobile) {
      justify-content: flex-end;
      .button {
        width: inherit;
      }
    }
  }
}
</style>
